import React, { useState } from 'react';
import ChargesBarcodes from './ChargesBarcodes';
import { CnabImportModal } from 'modules/debitCollections/components/CnabImport';

const AllChargesPage = () => {
	const [isCnabImportModalOpen, setIsCnabImportModalOpen] = useState(false);

	return (
		<>
			{/* <Flex justify="flex-end" gap={10}>
				{type !== AccessType.FINANCIAL_INSTITUTION &&
					permissions.includes(AccessPermission.CREATE_CHARGE) && (
						<Button
							style={{
								color: theme.primary,
							}}
							type="default"
							onClick={() => setIsCnabImportModalOpen(true)}
						>
							Upload de CNAB
							<BsArrowBarUp
								style={{ marginLeft: '0.6rem' }}
								size={18}
							/>
						</Button>
					)}
			</Flex> */}

			<ChargesBarcodes />
			<CnabImportModal
				isOpen={isCnabImportModalOpen}
				onClose={() => setIsCnabImportModalOpen(false)}
			/>
		</>
	);
};

export default AllChargesPage;
